@if (!fileEmitted) {
    <form [formGroup]="formGroup" class="flex flex-col">
        <div class="input-container">
            <label for="parsingTypeDropdown" i18n="@@bulkImports.importType">Type import</label>
            <p-select
                id="parsingTypeDropdown"
                [options]="typeOptions"
                formControlName="type"
                optionLabel="name"
                optionValue="type"
                placeholder="Selecteer type"
                i18n-placeholder="@@parsings.selectType"
                appendTo="body"
                styleClass="{{ stretch ? 'w-full' : 'w-64 self-baseline' }}"
            ></p-select>
        </div>
        <div class="{{ stretch ? 'w-full' : 'truncate w-64' }}">{{ fileName }}</div>
        <button
            type="button"
            class="button-primary mt-4 w-full"
            [class.self-baseline]="!stretch"
            (click)="fileInput.click()"
            (keypress)="fileInput.click()"
            i18n="@@button.uploadFile"
            >Selecteer bestand</button
        >
        @if (formData !== undefined && includeStartImportButton) {
            <button
                type="button"
                class="button-primary mt-4 w-full"
                [class.self-baseline]="!stretch"
                (click)="startImport()"
                (keypress)="startImport()"
                i18n="@@bulkImports.startImport"
                [disabled]="!formGroup.valid"
                >Start importeeractie</button
            >
        }
    </form>
}

<input
    #fileInput
    type="file"
    accept="{{ formGroup.controls.type.value === importType.TaxOnWeb ? '.pdf,.tow' : '.pdf' }}"
    hidden
    (change)="onFileSelected($event); fileInput.value = ''"
/>
